<template>
  <div>
    <v-dialog
        v-model="dialogProgress"
        max-width="800"
        persistent
    >
      <v-card>
        <v-card-title class="title primary white--text">{{titleDialog}}</v-card-title>
<!--
        <v-slider
            v-model="progress"
            min="0"
            max="100"
		    readonly
        ></v-slider>
-->
        <v-stepper :value="step">
          <v-stepper-header>
            <template v-for="n in steps">
                <v-stepper-step
                  :key="`${n}-step`"
                  :complete="step > n"
                  :step="n"
                  editable
                  @click="selectTuto(n)"
                >
                </v-stepper-step>
                <v-divider
                  v-if="n !== steps"
                  :key="n"
                ></v-divider>
              </template>
          </v-stepper-header>
        </v-stepper>
        <v-card-text v-html="contentDialog">
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" v-if="step !== 1" @click="previousTuto()">
            Précédent
          </v-btn>
          <v-btn class="primary" v-if="step !== 16" @click="nextTuto()">
            Suivant
            <v-icon right>send</v-icon>
          </v-btn>
          <v-btn class="blue--text darken-1" flat @click="quitTuto()"
          >
            Quitter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
    //   dialogProgress: false
    //   step: this.etape
      steps: 15
    }
  },
  props: ['openDialogProgress', 'dialogProgress', 'etape'],
  created () {
  },

  methods: {
    // ----------------------------------------------------------------------------
    // open la dialogBox
    // ----------------------------------------------------------------------------
    nextTuto () {
      console.log('this.step', this.step)
    //   this.installProgres = true
      // this.titleDialogProgress = data.title
      // this.contentDialogProgress = data.content
      if (this.step === 1) {
        this.$router.push({ path: '/settings/absence' })
      } else if (this.step === 2) {
        this.$router.push({ path: '/settings/chat' })
      } else if (this.step === 3) {
        this.$router.push({ path: '/settings/bot' })
      } else if (this.step === 4) {
        this.$router.push({ path: '/settings/callback' })
      } else if (this.step === 5) {
        this.$router.push({ path: '/settings/recall' })
      } else if (this.step === 6) {
        this.$router.push({ path: '/settings/sms' })
      } else if (this.step === 7) {
        this.$router.push({ path: '/settings/ecomm' })
      } else if (this.step === 8) {
        this.$router.push({ path: '/settings/connectors' })
      } else if (this.step === 9) {
        this.$router.push({ path: '/settings/bluepush' })
      } else if (this.step === 10) {
        this.$router.push({ path: '/management/agents' })
      } else if (this.step === 11) {
        this.$router.push({ path: '/account' })
      } else if (this.step === 12) {
        this.$router.push({ path: '/profile' })
      } else if (this.step === 13) {
        this.$router.push({ path: '/target/filters' })
      } else if (this.step === 14) {
        this.$router.push({ path: '/media/biblios' })
      } else if (this.step === 15) {
        this.$router.push({ path: '/stats/audience' })
      }
    },
    previousTuto () {
      if (this.step === 2) {
        this.$router.push({ path: '/settings/preview' })
      } else if (this.step === 3) {
        this.$router.push({ path: '/settings/absence' })
      } else if (this.step === 4) {
        this.$router.push({ path: '/settings/chat' })
      } else if (this.step === 5) {
        this.$router.push({ path: '/settings/bot' })
      } else if (this.step === 6) {
        this.$router.push({ path: '/settings/callback' })
      } else if (this.step === 7) {
        this.$router.push({ path: '/settings/recall' })
      } else if (this.step === 8) {
        this.$router.push({ path: '/settings/sms' })
      } else if (this.step === 9) {
        this.$router.push({ path: '/settings/ecomm' })
      } else if (this.step === 10) {
        this.$router.push({ path: '/settings/connectors' })
      } else if (this.step === 11) {
        this.$router.push({ path: '/settings/bluepush' })
      } else if (this.step === 12) {
        this.$router.push({ path: '/management/agents' })
      } else if (this.step === 13) {
        this.$router.push({ path: '/account' })
      } else if (this.step === 14) {
        this.$router.push({ path: '/profile' })
      } else if (this.step === 15) {
        this.$router.push({ path: '/target/filters' })
      } else if (this.step === 16) {
        this.$router.push({ path: '/media/biblios' })
      }
    },

    selectTuto (num) {
      if (num === 1) {
        this.$router.push({ path: '/settings/preview' })
      } else if (num === 2) {
        this.$router.push({ path: '/settings/absence' })
      } else if (num === 3) {
        this.$router.push({ path: '/settings/chat' })
      } else if (num === 4) {
        this.$router.push({ path: '/settings/bot' })
      } else if (num === 5) {
        this.$router.push({ path: '/settings/callback' })
      } else if (num === 6) {
        this.$router.push({ path: '/settings/recall' })
      } else if (num === 7) {
        this.$router.push({ path: '/settings/sms' })
      } else if (num === 8) {
        this.$router.push({ path: '/settings/ecomm' })
      } else if (num === 9) {
        this.$router.push({ path: '/settings/connectors' })
      } else if (num === 10) {
        this.$router.push({ path: '/settings/bluepush' })
      } else if (num === 11) {
        this.$router.push({ path: '/management/agents' })
      } else if (num === 12) {
        this.$router.push({ path: '/account' })
      } else if (num === 13) {
        this.$router.push({ path: '/profile' })
      } else if (num === 14) {
        this.$router.push({ path: '/target/filters' })
      } else if (num === 15) {
        this.$router.push({ path: '/media/biblios' })
      }
    },
    // ----------------------------------------------------------------------------
    // close la dialogBox
    // ----------------------------------------------------------------------------
    quitTuto () {
      // ferme le chat
    //   this.installProgres = false
      this.$emit('fermeDialogProgress')
      this.$store.commit('_User/ONGOING_TUTO', {
        ongoingTuto: false
      })
      this.$store.commit('_User/QUIT_TUTO', {
        tutoQuited: true
      })
    }
  },

  computed: {
    // à quelle etape ce trouve le conseiller
    step () {
    //   console.log('change etape', this.etape)
      return this.etape
    },

    progress () {
    //   console.log('change etape', this.etape)
      return this.etape * 10
    },

    titleDialog () {
      if (this.step === 1) {
        return 'Paramètres du "widget"'
      } else if (this.step === 2) {
        return 'Paramètres du mode "hors ligne"'
      } else if (this.step === 3) {
        return 'Paramètres du mode "en ligne"'
      } else if (this.step === 4) {
        return 'Paramètres du "chatbot"'
      } else if (this.step === 5) {
        return 'Paramètres de l\'option "Callback"'
      } else if (this.step === 6) {
        return 'Paramètres de l\'option "Meeting"'
      } else if (this.step === 7) {
        return 'Paramètres de l\'option "SMS"'
      } else if (this.step === 8) {
        return 'Paramètres "E-commerce"'
      } else if (this.step === 9) {
        return 'Paramètres des "Connecteurs"'
      } else if (this.step === 10) {
        return 'Paramètre des "Push Marketing"'
      } else if (this.step === 11) {
        return 'Gestion des sites web et des utilisateurs'
      } else if (this.step === 12) {
        return 'Gestion du Compte'
      } else if (this.step === 13) {
        return 'Gestion de votre "Profil"'
      } else if (this.step === 14) {
        return 'Ciblage comportemental'
      } else if (this.step === 15) {
        return 'Bibliothèques de phrases rapides'
      }
    },

    contentDialog () {
      let contentDialogProgress = ''
      if (this.step === 1) {
        contentDialogProgress = '<br>Le "widget", aussi appelé pop-up ou chatbox, est la petite fenêtre présente en bas de la page de votre site web, et dans laquelle on va afficher le chat ou le chatbot.'
        contentDialogProgress += '<p>Dans cette section vous allez personnaliser l\'aspect graphique du widget : <br><ul><li>couleur</li><li>position</li><li>dimensions</li><li>règles d\'affichage, pour lui dire où et quand s\'afficher</li><li>ect.</li></ul></p>'
        contentDialogProgress += '<p>Aux restrictions par horaires et/ou URLs, peut s\'ajouter la condition de la présence d\'un agent en ligne.</p>'
        contentDialogProgress += '<br><br>Pour valider les réglages du widget, cliquez sur "SAUVEGARDER" en bas à droite.'
      } else if (this.step === 2) {
        contentDialogProgress = '<br>Le mode "hors ligne" du widget signifie qu\'il n\'y a pas d\'agent disponible.'
        contentDialogProgress += '<p>Ici vous allez paramétrer ce que vous présentez aux internautes dans cette situation.<br>Vous avez le choix entre :<br><ul><li>le mode messaging (bientôt disponible)</li> <li>l\'affichage d\'un formulaire en absence.</li></ul></p>'
        contentDialogProgress += '<p>Les formulaires ainsi envoyés arriveront par e-mail au responsable du compte (paramétré dans la partie "gestion du compte").</p>'
        contentDialogProgress += '<br><br>Pour valider les réglages du mode hors-ligne, cliquez sur "SAUVEGARDER" en bas à droite.'
      } else if (this.step === 3) {
        contentDialogProgress = '<br>Le mode "en ligne" du widget signifie qu\'il y a au moins un agent connecté et en ligne pour répondre aux internautes par chat.'
        contentDialogProgress += '<p>Ici vous allez donc personnaliser le comportement du widget en mode chat.<br>Vous pouvez : <br><ul><li>envoyer une invitation à chatter automatique</li><li>imposer un formulaire d\'identification pre-chat</li><li>activer les fonctions de screen sharing (si vous avez souscrit à l\'option)</li><li>etc.</li></p>'
        contentDialogProgress += '<br><br>Pour valider le mode en-ligne, cliquez sur "SAUVEGARDER" en bas à droite.'
      } else if (this.step === 4) {
        contentDialogProgress = '<br>Le "Chatbot" est l\'agent conversationnel qui va prendre en charge vos internautes depuis le "widget".'
        contentDialogProgress += '<br>Si vous n\'avez pas souscrit à cette option, vous pouvez passer à l\'étape suivante. '
        contentDialogProgress += '<br><br>Vous pouvez ici choisir de restreindre l\'activation du chatbot à des pages ou des horaires spécifiques. En dehors de ces restrictions, ce sont les autres canaux par défaut qui prendront le relais (chat/messaging/formulaire).'
        contentDialogProgress += '<br><br>Si vous disposez de plusieurs chatbots, vous pouvez choisir lequel appliquer à votre site dans le sélecteur en bas à gauche.'
        contentDialogProgress += '<br>Pour valider le chatbot, cliquez sur "SAUVEGARDER" en bas à droite.'
      } else if (this.step === 5) {
        contentDialogProgress = '<br>La callback, aussi appelé "Click-to-call", est une option qui propose des rappels téléphoniques gratuits immédiats.'
        contentDialogProgress += '<br>Si vous n\'avez pas souscrit à cette option, vous pouvez passer à l\'étape suivante.'
        contentDialogProgress += '<br><br>Activez/désactivez ici la fonctionnalité, paramétrez où et quand afficher la tirette ainsi que les messages à afficher dans la fenêtre de demande de rappel.'
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite.'
      } else if (this.step === 6) {
        contentDialogProgress = '<br>La fonctionnalité "Meeting" est la prise de rendez-vous en ligne. Elle peut être synchronisée à votre agenda ou simplement notifiée par mail.'
        contentDialogProgress += '<br>Si vous n\'avez pas souscrit à cette option, vous pouvez passer à l\'étape suivante.'
        contentDialogProgress += '<br><br>Activez/désactivez ici la fonctionnalité, paramétrez où et quand afficher la tirette, le calendrier à synchroniser (ou pas) ainsi que les messages à afficher dans la fenêtre de demande de RDV.'
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite.'
      } else if (this.step === 7) {
        contentDialogProgress = '<br>La fonctionnalité "SMS" permet de vous notifier par SMS les moments clés de la relation client.'
        contentDialogProgress += '<br>Si vous n\'avez pas souscrit à cette option, vous pouvez passer à l\'étape suivante.'
        contentDialogProgress += '<br><br>Vous pouvez choisir ici de recevoir des SMS pour chaque nouvelle conversation, l\'envoi de messages en absence (hors-ligne) ou les demandes de rappel téléphonique (Callback).'
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite.'
      } else if (this.step === 8) {
        contentDialogProgress = '<br>Cette section est préparatoire à la section "Ciblage comportemental", si vous souhaitez utiliser le jeu de règles "e-commerce".'
        contentDialogProgress += '<br>Si votre activité n\'est pas axée sur le commerce en ligne (pas de tunnel d\'achat), vous pouvez passer à l\'étape suivante.'
        contentDialogProgress += '<br><br>Ici vous pouvez donc apprendre à Target First comment se compose et se comporte votre tunnel d\'achat. Identifiez chaque page de votre tunnel et reportez les dans les différentes sections.'
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite.'
      } else if (this.step === 9) {
        contentDialogProgress = '<br>Connectez votre solution Target First aux outils du marchés.'
        contentDialogProgress += '<br><br>Target First propose des canaux de communication inter-plateformes (Slack, Messenger) et d\'outils de relation client (Salesforce, Zendesk).'
        contentDialogProgress += '<br><br>Pour chaque outil, vous pouvez ici paramétrer les connecteurs en renseignant des identifiants "API" des différentes solutions tiers.'
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite.'
      } else if (this.step === 10) {
        contentDialogProgress = '<br>Cette section permet d\'envoyer des pushs de manière systématique.'
        contentDialogProgress += '<br>Si vous n\'avez pas souscrit à cette option, vous pouvez passer à l\'étape suivante.'
        contentDialogProgress += '<br><br>Les "push-marketing" sont des fenêtres qui s\'affichent de manière automatique sur votre site. Ici vous pouvez paramétrer où et quand envoyer ces pushs. Pour les construire, rendez-vous sur la section "Media" -> "Push Marketing".'
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite.'
      } else if (this.step === 11) {
        contentDialogProgress = '<br>Personnalisez ici le profil des utilisateurs ainsi que les sites liés à votre licence.'
        contentDialogProgress += '<br><br>Activez/désactivez Target First sur vos sites internet et affectez leur des utilisateurs (téléconseillers).'
        contentDialogProgress += '<br>Définissez également les URLs de vos sites et choisissez un contact (mail) qui recevra les notifications.'
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite de chaque utilisateur/site concerné.'
      } else if (this.step === 12) {
        contentDialogProgress = '<br>Dans cette section, vous pouvez vérifier les informations relatives à votre compte et vos abonnements.'
        contentDialogProgress += '<br><br>Pour accéder à cette section, cliquez sur votre avatar <img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_user.png"> ici en haut à droite de l\'écran, puis sélectionnez "Gestion du compte".'
        contentDialogProgress += '<br><br>Seul le "référent facturation" peut accéder aux factures ou éditer des offres. Pour accéder à cette partie il doit cliquer sur le bouton "Voir Abonnement".'
      } else if (this.step === 13) {
        contentDialogProgress = '<br>Modifiez ici vos informations personnelles.'
        contentDialogProgress += '<br><br>Pour accéder à cette section, cliquez sur votre avatar <img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_user.png"> en haut à droite de l\'écran, puis re-cliquez dessus.'
        contentDialogProgress += '<br><br>Vous pouvez ici vous attribuez un avatar, personnaliser votre profil ainsi que la fiche visiteur pour lorsque vous chattez.'
      } else if (this.step === 14) {
        contentDialogProgress = '<br>Ciblez et invitez vos internautes.'
        contentDialogProgress += '<br>Si vous n\'avez pas souscrit à cette option, vous pouvez passer à l\'étape suivante.'
        contentDialogProgress += '<br><br>Ici vous définissez les scenarii de ciblage de vos internautes. Chaque ligne correspond à un scénario, lui même décomposé en trois étapes simples : <br><ol><li>description</li><li>déclencheurs</li><li>comportement</li></ol>'
        contentDialogProgress += '<br><br>Paramétrez chaque scénario, assurez-vous d’avoir renseigné les 3 étapes,  puis activez-le. Celui-ci sera fonctionnel quand un conseiller sera connecté et en ligne (et actif sur la section trafic)'
        contentDialogProgress += '<br><br>Prenez du temps pour bien maîtriser cette section, indispensable à la performance de votre Target First.'
      } else if (this.step === 15) {
        contentDialogProgress = '<br>Créez, en quelques clics, des bibliothèques de phrases pré-définies pour le chat.'
        contentDialogProgress += '<br><br>Ces phrases vous seront proposées de manière automatique lorsque vous rédigerez des messages aux visiteurs.'
        contentDialogProgress += '<br><br>Vous pourrez aussi les modifier à la volée pour personnaliser votre échange avec l’internaute.'
        contentDialogProgress += '<br><br>Saisissez les phrases récurrentes (politesse, métier, FAQ) qui seront utilisées lors de vos conversations chat.'
      } else if (this.step === 16) {
        contentDialogProgress = '<br>Félicitations, vous avez fait le tour des paramétrages de votre backoffice.'
        contentDialogProgress += '<br><br>Les icônes en haut à droite du backoffice vous proposent plusieurs aides :<br>'
        contentDialogProgress += '<strong>'
        contentDialogProgress += '<br><img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_boussole.png"> Visite guidée'
        contentDialogProgress += '<br><img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_chatbot.png"> Chatbot d\'aide'
        contentDialogProgress += '<br><img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_bug.png"> Contact support'
        contentDialogProgress += '<br><img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_aide.png"> Centre d\'aide'
        contentDialogProgress += '<br><img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_notif.png"> Centre de notifications'
        contentDialogProgress += '</strong>'
        contentDialogProgress += '<br><br>Vous pouvez à tout moment recommencer cette visite en cliquant sur l\'icône visite guidée <img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_boussole.png"  tout en haut.'
        contentDialogProgress += '<br><br>Si vous avez des questions, notre chatbot <img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_chatbot.png"> propose d\'interagir avec notre site support <a href="https://support.targetfirst.com" target="_blank" >https://support.targetfirst.com</a>'
      }
      return contentDialogProgress
    }
  },

  watch: {
    // titleDialogProgress: function (v) {
    //   console.log('v', v)
    //   if (v) {
    //     this.openDialog()
    //     // this.getOptions()
    //   }
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheebox/WzDialogProgress.vue